import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=e490822c&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=e490822c&prod&scoped=true&lang=css"
import style1 from "./Create.vue?vue&type=style&index=1&id=e490822c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e490822c",
  null
  
)

export default component.exports